import { render, staticRenderFns } from "./splitBill.vue?vue&type=template&id=650e15b0&scoped=true&"
import script from "./splitBill.vue?vue&type=script&lang=js&"
export * from "./splitBill.vue?vue&type=script&lang=js&"
import style0 from "./splitBill.vue?vue&type=style&index=0&id=650e15b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650e15b0",
  null
  
)

export default component.exports